// 来源于 redux-saga
// 只实现了标准 channel 部分
import { once } from 'lodash-es';

import { CHANNEL_END, SAGA_ACTION, MATCH } from './innerActionSymbol';
import { asap } from './taskSchedule';

export const END = { type: CHANNEL_END };
export const isEnd = (a) => {
	// console.log(CHANNEL_END, a, a.type);
	return a && a.type === CHANNEL_END;
};
// 类似于事件监听池， 事件触发后需要将相关的值发布到channel中去，在task执行过程中会将channel中的值消耗掉
const multiChannel = () => {
	let closed = false;
	let currentTakers = [];
	let nextTakers = currentTakers;

	const close = () => {
		closed = true;
		const takers = (currentTakers = nextTakers);
		nextTakers = [];
		takers.forEach((taker) => {
			taker(END);
		});
	};
	const ensureCanMutateNextTakers = () => {
		if (nextTakers !== currentTakers) {
			return;
		}
		nextTakers = currentTakers.slice();
	};

	return {
		multiChannel: true,
		put(input) {
			if (closed) {
				return;
			}
			if (isEnd(input)) {
				close();
				return;
			}
			const takers = (currentTakers = nextTakers);
			// 遍历takers，找出符合类型的taker，并消耗
			// console.log('TAKES-IN-PUT', takers);
			for (let i = 0, len = takers.length; i < len; i++) {
				const taker = takers[i];
				if (taker[MATCH](input)) {
					// console.log('MATCH',input.type);
					taker.cancel();
					taker(input);
				}
			}
		},
		take(cb, matcher) {
			// 在takers中加入该函数，并赋予taker一个cancel方法，用于在takers中移除
			if (closed) {
				cb(END);
				return;
			}
			cb[MATCH] = matcher;
			ensureCanMutateNextTakers();
			cb.cancel = once(function () {
				ensureCanMutateNextTakers();
				let idx = nextTakers.indexOf(cb);
				// console.log('in cancel, idx', idx, matcher);
				if (idx > -1) {
					// console.log(idx);
					nextTakers.splice(idx, 1);
				}
			});
			nextTakers.push(cb);
		},
		close,
	};
};

export const stdChannel = () => {
	const chan = multiChannel();
	const { put } = chan;
	chan.put = (input) => {
		// 如果，action来自于内部的put，则说明已经asap过了，防止重复
		if (input[SAGA_ACTION]) {
			put(input);
			return;
		}
		//action直接来源于store.dispatch
		asap(() => put(input));
	};
	return chan;
};
